import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

import "./_style.scss";

const TimelineQuote = ({
  align,
  annotation,
  text,
  ...other
}) => (
  <div
    className={
        classNames({
          "timeline-quote": true,
          [`--align-${align}`]: align,
        })
      }
    {...other}
  >
    <div className="timeline-quote__inner">
      <div className="timeline-quote__text">
        &lsquo;
        {text}
        &rsquo;
      </div>
      <div className="timeline-quote__annotation">{annotation}</div>
    </div>
  </div>
);

TimelineQuote.propTypes = {
  align: PropTypes.oneOf(["left", "right"]).isRequired,
  annotation: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  text: PropTypes.string.isRequired,
};

export default TimelineQuote;
